import { Link } from 'react-router-dom';
import { Container } from '@dma/ui';
import type { AboutContentDto } from '../application/dto/AboutContentDto';
import './AboutCTA.css';

export interface AboutCTAProps {
  label: AboutContentDto['ctaLabel'];
  href: AboutContentDto['ctaHref'];
}

/**
 * Renders a button-styled Link/anchor, following the same pattern as
 * features/home/components/Hero.tsx (the shared `Button` component only
 * renders a native <button>, so it cannot itself be used as a link).
 * Styling is self-contained in AboutCTA.css rather than assuming
 * packages/ui's Button.css happens to already be loaded by another
 * component elsewhere in the bundle.
 */
export function AboutCTA({ label, href }: AboutCTAProps) {
  const isExternal = /^https?:\/\//.test(href);

  return (
    <section className="dma-about-cta">
      <Container>
        {isExternal ? (
          <a className="dma-about-cta__button" href={href}>
            {label}
          </a>
        ) : (
          <Link className="dma-about-cta__button" to={href}>
            {label}
          </Link>
        )}
      </Container>
    </section>
  );
}
